export enum CurvaCEVAEnum {
  A = 0,
  B = 1,
  C = 2
}
